module.exports = __webpack_public_path__ + "img/jiance_fengmian.0887a242.png";